import { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import format from 'date-fns/format';
import {
  SubHeader,
  NotificationCommit,
  NotificationCreateConfirm,
  NotificationCreateForm,
} from '../../components';
import { fetch } from '../../functions';
import withFormStatus, { FormStatusProps } from '../../hoc/withFormStatus';
import useStyles from '../../assets/styles/Master.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Params = {
  id: string;
};

/**
 *
 *
 *
 * @method Validation
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
export const schema = yup.object({
  from: yup.string().required('投稿者名を入力してください'),
  title: yup.string().required('タイトルを入力してください'),
  description: yup.string().required('本文を入力してください'),
});

/**
 *
 *
 *
 * @method Components
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const NotificationsCreate: FC<FormStatusProps> = (props) => {
  const { mode, changeMode } = props;
  const classes = useStyles();
  const { id } = useParams<Params>();
  const [workSite, setWorkSite] = useState<any>();

  //  フォームの定義
  const formik = useFormik({
    initialValues: {
      postDate: format(new Date(), 'yyyy/MM/dd'),
      from: '',
      title: '',
      description: '',
    },
    validationSchema: schema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, actions) => {
      if (mode === 'editing') {
        changeMode('confirm');
      } else {
        const result = await fetch.post(`/work_site/${id}/notification`, {
          postDate: format(new Date(values.postDate), 'yyyy/MM/dd 00:00:00'),
          title: values.title,
          description: values.description,
          from: values.from,
        });

        if (result.status === 200) {
          changeMode('commit');
        }
      }
    },
  });

  //サブヘッダー用の現場情報を取得。
  useEffect(() => {
    (async () => {
      const workSite = await fetch.get(`/work_site/${id}`);
      if (workSite.status === 200) {
        setWorkSite(workSite.data);
      }
    })();
  }, [id]);

  return (
    <>
      <SubHeader
        title={workSite?.name}
        subTitle={`お知らせ追加${
          { editing: '', confirm: '(確認)', commit: '(完了)' }[mode]
        }`}
        link={`/dashboard/workSite/${id}`}
      />

      <div className={classes.root}>
        {mode === 'editing' && <NotificationCreateForm {...formik} />}
        {mode === 'confirm' && <NotificationCreateConfirm {...formik} />}
        {mode === 'commit' && (
          <NotificationCommit
            message={`お知らせを新規作成しました。\nお知らせ一覧ページから確認してください。`}
            link={`/workSite/${id}/notifications`}
          />
        )}
      </div>
    </>
  );
};

export default withFormStatus(NotificationsCreate);
